import componentsToInititalize from  './component-index.generated'
import Store from './store'
import '@nykredit/design-system-icons'
import { NdsIcon } from '@nykredit/design-system-vue'

const originalInstall = Store.install.bind(Store)
Store.install = (app) => {
    originalInstall(app)
    app.component('NdsIcon', NdsIcon)
}

componentsToInititalize(Store)


